import { useEffect, useState } from 'react';

export type DeviceType = 'android' | 'ios' | 'other';

export default function useDeviceType(): DeviceType {
  const getDeviceType = (): DeviceType => {
    if (typeof window === 'undefined') return 'other';

    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    
    // Check for Android devices
    if (/Android.*Mobile/i.test(userAgent)) {
      return 'android';
    }
    
    // Check for iOS devices (iPhone, iPod)
    if (/iPhone|iPod/i.test(userAgent)) {
      return 'ios';
    }
    
    return 'other';
  };

  const [deviceType, setDeviceType] = useState<DeviceType>(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return deviceType;
}
